import { useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { useInvoiceQuery } from '../../../api/gql';
import { useSafeNavigation } from '../../../hooks/useSafeNavigation';
import { EndRemindingModule } from '../../../modules/dialogs/end-reminding';

export const InvoiceEndRemindingPage = () => {
  const { invoiceId } = useParams();
  const { safeNavigate } = useSafeNavigation();
  const queryClient = useQueryClient();

  if (!invoiceId) {
    throw new Error('Invoice id is required');
  }

  return (
    <EndRemindingModule
      invoiceId={invoiceId}
      transNs={'page-invoice-end-reminding'}
      onSuccess={({ endReminding }) => {
        queryClient.setQueryData(useInvoiceQuery.getKey({ id: endReminding.id }), {
          invoice: { ...endReminding },
        });
        safeNavigate(`/invoice/${endReminding.id}`);
      }}
    />
  );
};
